// extracted by mini-css-extract-plugin
export default {"container":"ItemsNotFound_container__s1YNR","icon":"ItemsNotFound_icon__tBPrT","title":"ItemsNotFound_title__woCkH"};